export default __webpack_public_path__ + "static/media/testimonial_img2.75ef85c9.png";